<svg
  viewBox="0 0 5 496"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
  style={$$restProps.style}
>
  <path d="M2.36425 2L2.36424 494" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
  <path
    d="M2.53492 3.27734C2.53492 13.4761 2.39227 23.6664 3.2717 33.7798C3.96781 41.7852 3.48501 50.4113 2.93489 58.3881C2.33035 67.1538 2.91383 76.1492 2.91383 84.933C2.91383 91.8447 2.91383 98.7563 2.91383 105.668C2.91383 107.156 2.91383 108.643 2.91383 110.131C2.91383 110.566 2.9111 112.575 2.99804 112.488C3.32047 112.166 3.67166 111.491 3.67166 111.731C3.67166 114.123 3.32577 116.468 3.29275 118.846C3.19976 125.541 2.23055 132.219 2.15601 138.928C2.07952 145.812 2.06173 152.717 2.15601 159.6C2.23161 165.118 2.91383 170.691 2.91383 176.272C2.91383 179.359 2.91383 182.447 2.91383 185.534"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M2.91343 185.533C2.91343 194.627 2.91343 203.721 2.91343 212.815C2.91343 224.08 1.01886 235.234 1.01886 246.517C1.01886 250.719 0.976419 254.924 1.01886 259.126C1.07559 264.742 2.1556 270.286 2.1556 275.904C2.1556 280.385 2.07263 284.875 2.1556 289.355C2.17764 290.545 2.65125 296.686 2.91343 296.555"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M2.9133 293.797C2.9133 305.038 2.9133 316.279 2.9133 327.52C2.9133 335.497 3.50306 473.465 1.93454 481.307C1.31998 484.38 2.01874 487.381 2.01874 490.486"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
